module.exports = __webpack_public_path__ + "static/media/AVeryBigFallCase.af55ffe3.jpg";